// import React from "react";
// import { useLocation, useParams } from "react-router-dom";

// // UI
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";
// import MDBox from "components/MDBox";

// import EmptyState from "./EmptyState";
// import YouTubeResponse from "./YouTubeResponse";
// import FacebookResponse from "./FacebookResponse";
// import InstagramResponse from "./InstagramResponse";

// function ResponseRouter() {
//   const location = useLocation();
//   const { platform, status } = useParams();

//   const params = new URLSearchParams(location.search);

//   const platformQP = params.get("platform");
//   const statusQP = params.get("status");
//   const oauthCode = params.get("code");
//   const error = params.get("error");

//   const finalPlatform = platform || platformQP;
//   const finalStatus = status || statusQP;

//   if (!finalPlatform || !finalStatus) {
//     return (
//       <DashboardLayout>
//         <DashboardNavbar />
//         <EmptyState />
//         <Footer />
//       </DashboardLayout>
//     );
//   }

//   const renderPlatform = () => {
//     switch (finalPlatform.toLowerCase()) {
//       case "youtube":
//         return (
//           <YouTubeResponse
//             status={finalStatus}
//             oauthCode={oauthCode}
//             error={error}
//           />
//         );

//       case "facebook":
//         return (
//           <FacebookResponse
//             status={finalStatus}
//             oauthCode={oauthCode}
//             error={error}
//           />
//         );

//       case "instagram":
//         return (
//           <InstagramResponse
//             status={finalStatus}
//             oauthCode={oauthCode}
//             error={error}
//           />
//         );

//       default:
//         return <EmptyState />;
//     }
//   };

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <MDBox mt={8} mb={4}>
//         {renderPlatform()}
//       </MDBox>
//       <Footer />
//     </DashboardLayout>
//   );
// }

// export default ResponseRouter;


// ############################################


// comparedly-frontend\src\layouts\components\ConnectOwnProfile\response\ResponseRouter.js

import React, { useEffect, useState } from "react"; // <-- Import useEffect and useState
import { useLocation, useParams, useNavigate } from "react-router-dom"; // <-- Import useNavigate
import OAuthService from "services/oauth-service"; // <-- Import the new service

// UI
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography"; // Needed for loading text

import EmptyState from "./EmptyState";
import YouTubeResponse from "./YouTubeResponse";
import FacebookResponse from "./FacebookResponse";
import InstagramResponse from "./InstagramResponse";

function ResponseRouter({ platform: propPlatform, status: propStatus }) {
  const location = useLocation();
  const navigate = useNavigate(); // Initialize navigate hook

  const { platform: paramPlatform, status: paramStatus } = useParams(); // URL path parameters (e.g., /connect/profile/response/youtube/success)

  const params = new URLSearchParams(location.search);

  const platformQP = params.get("platform");
  const statusQP = params.get("status");
  const oauthCode = params.get("code");
  const error = params.get("error");

  // Priority: Prop > Param > QueryParam
  const finalPlatform = propPlatform || paramPlatform || platformQP;
  const finalStatus = propStatus || paramStatus || statusQP;

  // State for securing the page
  const [isValidated, setIsValidated] = useState(false);
  const [isResponseLoading, setIsResponseLoading] = useState(true);

  // --- NEW VALIDATION EFFECT ---
  useEffect(() => {
    // 1. Guard check for missing URL parameters
    if (!finalPlatform || !finalStatus) {
      setIsResponseLoading(false);
      // We still render EmptyState if they hit the route without params
      return;
    }

    const validateAndConsumeStatus = async () => {
      try {
        // Call the secure backend endpoint to check the DB status and consume it
        const response = await OAuthService.validateResponse(finalPlatform, finalStatus);

        // Check the response status (200 OK means success: true was returned)
        if (response.success === true) {
          setIsValidated(true);
        } else {
          // Validation failed (status mismatch or already consumed)
          console.warn("OAuth status validation failed or status was already consumed.");
          navigate("/dashboard", { replace: true });
        }
      } catch (err) {
        // Catch 401/500 errors from HttpService, meaning validation failed
        console.error("Error during OAuth status validation:", err.message);
        navigate("/dashboard", { replace: true });
      } finally {
        setIsResponseLoading(false);
      }
    };

    validateAndConsumeStatus();
  }, [finalPlatform, finalStatus, navigate]);


  // --- RENDERING GUARDS ---

  // 1. Show loading state while validation is in progress
  if (isResponseLoading) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox textAlign="center" mt={8}>
          <MDTypography variant="h5">Securing connection status...</MDTypography>
        </MDBox>
        <Footer />
      </DashboardLayout>
    );
  }

  // 2. If validation failed, the useEffect hook already redirected.
  if (!isValidated) {
    return null;
  }

  // 3. If validation passed, check if initial URL parameters were missing 
  // (should only run if validation passed, but kept for robustness)
  if (!finalPlatform || !finalStatus) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <EmptyState />
        <Footer />
      </DashboardLayout>
    );
  }

  // --- FINAL RENDER (Only runs if isValidated is true) ---
  const renderPlatform = () => {
    switch (finalPlatform.toLowerCase()) {
      case "youtube":
        return (
          <YouTubeResponse
            status={finalStatus}
            oauthCode={oauthCode}
            error={error}
          />
        );

      case "facebook":
        return (
          <FacebookResponse
            status={finalStatus}
            oauthCode={oauthCode}
            error={error}
          />
        );

      case "instagram":
        return (
          <InstagramResponse
            status={finalStatus}
            oauthCode={oauthCode}
            error={error}
          />
        );

      default:
        return <EmptyState />;
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={8} mb={4}>
        {renderPlatform()}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default ResponseRouter;